const state = {
    departments: [],
    department_list: [],
    department: {},
    parent_departments: [],
}

export default state;
